import { HiOutlineExclamation, HiOutlineX } from "react-icons/hi";

interface IncompleteAppSettingsModalProps {
  open: boolean;
  onDismiss: () => void;
  onComplete: () => void;
}

export default function IncompleteAppSettingsModal({
  open,
  onDismiss,
  onComplete,
}: IncompleteAppSettingsModalProps): JSX.Element | null {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center px-4"
      style={{ fontFamily: "Inter, sans-serif" }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="incomplete-app-settings-title"
    >
      <div
        className="fixed inset-0 bg-[#222] opacity-60"
        aria-hidden
        onClick={onDismiss}
      />
      <div className="relative z-10 flex w-full max-w-[440px] flex-col gap-5 rounded-[10px] bg-white shadow-lg">
        <div className="flex shrink-0 items-center justify-between border-b border-solid border-[#e3e3e3] p-5">
          <div className="flex items-center gap-2">
            <span className="flex size-8 items-center justify-center rounded-full bg-[#FEF3C7]">
              <HiOutlineExclamation className="size-5 text-[#D97706]" strokeWidth={2} />
            </span>
            <h2
              id="incomplete-app-settings-title"
              className="text-base font-semibold leading-5 text-[#222]"
            >
              Complete App Settings
            </h2>
          </div>
          <button
            type="button"
            onClick={onDismiss}
            className="flex size-5 items-center justify-center rounded text-[#6d6d6d] hover:bg-[#eee] hover:text-[#222]"
            aria-label="Close"
          >
            <HiOutlineX className="size-5" strokeWidth={2} />
          </button>
        </div>
        <div className="px-5">
          <p className="text-sm leading-5 text-[#555]">
            App settings have not been configured yet. Please complete the App
            Settings to enable invoicing, fees and other workflows.
          </p>
        </div>
        <div className="flex shrink-0 items-center justify-end gap-2 border-t border-solid border-[#eee] p-3">
          <button
            type="button"
            onClick={onDismiss}
            className="rounded-md border border-solid border-[#eee] bg-white px-4 py-2 text-xs font-semibold leading-5 text-[#6d6d6d] hover:bg-[#f5f5f5]"
          >
            Later
          </button>
          <button
            type="button"
            onClick={onComplete}
            className="rounded-md bg-[#222] px-4 py-2 text-xs font-semibold leading-5 text-white hover:bg-[#333]"
          >
            Complete now
          </button>
        </div>
      </div>
    </div>
  );
}
